import { Box, Text } from '@chakra-ui/react';

const DateSeparator = ({ colors }) => (
    <Box display="flex" alignItems="center" justifyContent="center" py={3} px={4}>
        <Text fontSize="xs" color={colors.dateText}>
            Dzisiaj · Rozmowa rekrutacyjna
        </Text>
    </Box>
);

export default DateSeparator;
